import { ReadiedRoute, Redirect } from "@itandi/tools/next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/deals/[id]/billing_rentees/edit/Page";

export const PATH = (id: number): string => `/deals/${id}/billing_rentees/edit`;

function Billings() {
	return (
		<ReadiedRoute fallback={<Redirect url="/" />}>
			<NskHead title="入居者への請求明細" />
			<Component />
		</ReadiedRoute>
	);
}

export default Billings;
